import type { JSX } from 'react';
import { Navigate, useParams } from 'react-router';

import NotificationCenterLayout from './NotificationCenterLayout';

const NotificationCenterPage = (): JSX.Element => {
  const { masterProjectId } = useParams<{ masterProjectId: string }>();
  const id = Number(masterProjectId);

  if (!masterProjectId || Number.isNaN(id)) {
    return <Navigate to="/project" replace />;
  }

  return <NotificationCenterLayout masterProjectId={id} />;
};

export default NotificationCenterPage;
